import { render } from "./AndroidCardNl.vue?vue&type=template&id=4698c6c8&scoped=true"
import script from "./AndroidCardNl.vue?vue&type=script&lang=js"
export * from "./AndroidCardNl.vue?vue&type=script&lang=js"

import "./AndroidCardNl.vue?vue&type=style&index=0&id=4698c6c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4698c6c8"]])

export default __exports__